import React from "react";
import AllOrders from "./_components/AllOrders";
import PermissionGuard from "../../components/PermissionGuard";

const OrderManagement: React.FC = () => {
  return (
    <PermissionGuard module="orders" action="read">
      <div className="p-6 pt-0">
        <AllOrders />
      </div>
    </PermissionGuard>
  );
};

export default OrderManagement;
